import { ReactNode } from "react";
import classNames from "classnames";

type BannerType = "warning";

const BANNER_CLASSES: Record<BannerType, string> = {
  warning: "bg-orange text-white",
};

export const Banner = ({
  children,
  type,
}: {
  children: ReactNode;
  type: BannerType;
}) => (
  <div className={classNames("w-full flex-col", BANNER_CLASSES[type])}>
    <div className="p-8 text-center">{children}</div>
  </div>
);
